export default {
    repaymentFirst: "Mangyaring tapusin ang pagbabayad at mag-withdraw pagkatapos",
    upAmount: "Mangyaring magbayad sa oras upang paganahin ang paulit-ulit na pautang na may nadagdagan credit limit",
    repaymentCode: "Code sa pagbabayad",
    checkRepaymentCode: "Check Repayment Code",
};
